/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WidgetCategory = {
    Regular: 'Regular',
    Kpi: 'Kpi'
} as const;
export type WidgetCategory = typeof WidgetCategory[keyof typeof WidgetCategory];


export function instanceOfWidgetCategory(value: any): boolean {
    for (const key in WidgetCategory) {
        if (Object.prototype.hasOwnProperty.call(WidgetCategory, key)) {
            if (WidgetCategory[key as keyof typeof WidgetCategory] === value) {
                return true;
            }
        }
    }
    return false;
}

export function WidgetCategoryFromJSON(json: any): WidgetCategory {
    return WidgetCategoryFromJSONTyped(json, false);
}

export function WidgetCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetCategory {
    return json as WidgetCategory;
}

export function WidgetCategoryToJSON(value?: WidgetCategory | null): any {
    return value as any;
}

export function WidgetCategoryToJSONTyped(value: any, ignoreDiscriminator: boolean): WidgetCategory {
    return value as WidgetCategory;
}

